import { Card, CardContent, CardHeader } from '@/common/components/Card.tsx'
import {
  Command,
  CommandEmpty,
  CommandItem,
  CommandList,
} from '@/shad/ui/command.tsx'
import { useSelector } from 'react-redux'
import { RootState } from '@/storage/store.ts'
import AddLinkPopup from '@/pages/setup/link_handlers/wallet_handbook_link/components/AddLinkPopup.tsx'
import EditLinkPopup from '@/pages/setup/link_handlers/wallet_handbook_link/components/EditLinkPopup.tsx'

interface HandbookLink {
  id: number
  program_id: number
  link: string
}

interface Props {
  onHandbookLinkChange: () => Promise<void>
  handbookLinks: HandbookLink[]
  invalidateHandbookLinks: () => void
}

const WalletHandbookLinkList = (props: Props) => {
  const { handbookLinks, invalidateHandbookLinks, onHandbookLinkChange } = props

  const rol = useSelector((state: RootState) => state.auth.roles)

  const handleCategoryChange = () => {
    if (onHandbookLinkChange) {
      onHandbookLinkChange()
    }
    invalidateHandbookLinks()
  }

  function contains(array: string[], ...values: string[]): boolean {
    return values.some((value) => array.includes(value))
  }

  return (
    <Card className="mt-5">
      <CardHeader className="py-2">
        <div className="flex items-center justify-between">
          <h3 className="font-medium">Wallet Handbook Links</h3>
          <div>
            {contains(rol, 'admin', 'program_manager') && (
              <AddLinkPopup onAddHandbookLinkSuccess={handleCategoryChange} />
            )}
          </div>
        </div>
      </CardHeader>
      <CardContent className="w-full">
        <div className="w-full">
          <Command className="h-full">
            <div className="h-full w-full">
              <CommandList className="w-full h-full py-2">
                {handbookLinks.length === 0 ? (
                  <CommandEmpty>No Handbook Links available.</CommandEmpty>
                ) : (
                  handbookLinks.map((handbookLink) => (
                    <CommandItem
                      className="text-gray-600 hover:text-gray-600 justify-between data-[selected=true]:text-gray-600 data-[selected=true]:bg-transparent"
                      key={handbookLink.id}
                      value={handbookLink.link}
                    >
                      <div>
                        <div className="font-medium text-gray-800">
                          {handbookLink.link}
                        </div>
                      </div>
                      {contains(rol, 'admin', 'program_manager') && (
                        <EditLinkPopup
                          handbookLinks={handbookLinks}
                          linkId={handbookLink.id}
                          currentLink={handbookLink.link}
                          onEditHandbookLinkSuccess={() => {
                            invalidateHandbookLinks()
                          }}
                        />
                      )}
                    </CommandItem>
                  ))
                )}
              </CommandList>
            </div>
          </Command>
        </div>
      </CardContent>
    </Card>
  )
}
export default WalletHandbookLinkList
